import React, { useCallback, useEffect, useState } from 'react';
import { fetchData, postData } from '../../Utils/Server';
import Endpoints from '../../Constants/Endpoints';
import { ReasonCaptureModal } from '../Common/ReasonCaptureModal';
import { Guard } from '../Common/Guard';
import { PERMS } from '../../Utils/Permissions';
import PageLayout from '../Layout/PageLayout';
import { Card, DataTable, Button, StatusBadge } from '../UI';

export default function FlaggedUsers() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pendingUser, setPendingUser] = useState(null);
  const [pendingOn, setPendingOn] = useState(true);

  const load = useCallback(() => {
    fetchData(Endpoints.LIST_FLAGGED_USERS)
      .then((r) => r.json())
      .then((res) => {
        setRows((res && res.data) || res || []);
        setLoading(false);
      });
  }, []);

  useEffect(load, [load]);

  const submit = (reason) => {
    const fd = new FormData();
    fd.append('on', pendingOn ? 'true' : 'false');
    fd.append('reason', reason);
    postData(Endpoints.TOGGLE_PREPAY_ONLY(pendingUser.id), fd)
      .then(() => { setPendingUser(null); load(); });
  };

  const columns = [
    { name: 'Name', selector: 'name' },
    { name: 'Phone', selector: 'phone' },
    { name: 'Low rating', cell: (row) => row.low_rating_flag ? <StatusBadge tone="warn">Warning</StatusBadge> : '-' },
    { name: 'Pre-pay only', cell: (row) => row.pre_pay_only ? <StatusBadge tone="info">Yes</StatusBadge> : '-' },
    {
      name: 'Action',
      cell: (row) => (
        <Guard permission={PERMS.ADMIN_WRITE}>
          <Button size="sm" variant="outline" onClick={() => { setPendingUser(row); setPendingOn(!row.pre_pay_only); }}>
            {row.pre_pay_only ? 'Disable pre-pay-only' : 'Set pre-pay-only'}
          </Button>
        </Guard>
      ),
    },
  ];

  return (
    <PageLayout title="Flagged users">
      <Card padded={false}>
        <DataTable columns={columns} data={rows} progressPending={loading} noHeader={true} />
      </Card>
      {pendingUser && (
        <ReasonCaptureModal
          title={pendingOn ? 'Set user to pre-pay only' : 'Disable pre-pay-only requirement'}
          onCancel={() => setPendingUser(null)}
          onConfirm={submit}
        />
      )}
    </PageLayout>
  );
}
